// Components==============
import DreamModal from 'components/UI/DreamModal/DreamModal';
import { AnimatePresence } from 'framer-motion';
import React, { useContext, useEffect } from 'react';
import { GlobalRootDreamContext } from 'utilities/GlobalContext/GlobalRootDream';
import { GlobalRootPersonContext } from 'utilities/GlobalContext/GlobalRootPerson';
import { GlobalRootSkillContext } from 'utilities/GlobalContext/GlobalRootSkill';
import PersonModal from '../PersonModal/PersonModal';
import SkillModal from '../SkillModal/SkillModal';
// =========================

const Dream = () => {
  const { rootDreamModal, setRootDreamModal } = useContext(
    GlobalRootDreamContext
  );

  useEffect(() => setRootDreamModal(undefined), []);

  return (
    <AnimatePresence>
      {!!rootDreamModal && (
        <DreamModal
          setModalIsOpen={() => setRootDreamModal(undefined)}
          dream={rootDreamModal.dream}
          origin={rootDreamModal.origin}
          editOnOpen={rootDreamModal.edit}
        />
      )}
    </AnimatePresence>
  );
};

const Skill = () => {
  const { rootSkillModal, setRootSkillModal } = useContext(
    GlobalRootSkillContext
  );

  useEffect(() => setRootSkillModal(undefined), []);

  return (
    <AnimatePresence>
      {!!rootSkillModal && (
        <SkillModal
          setSkillModalIsOpen={() => setRootSkillModal(undefined)}
          selectedSkill={rootSkillModal}
        />
      )}
    </AnimatePresence>
  );
};

const Person = () => {
  const { rootPersonModal, setRootPersonModal } = useContext(
    GlobalRootPersonContext
  );

  useEffect(() => setRootPersonModal(undefined), []);

  return (
    <AnimatePresence>
      {!!rootPersonModal && (
        <PersonModal
          setModalIsOpen={() => setRootPersonModal(undefined)}
          person={rootPersonModal}
        />
      )}
    </AnimatePresence>
  );
};

export default function RootReflectionModal({
  type,
}: {
  type: 'dream' | 'skill' | 'person';
}) {
  return (
    <>
      {type === 'dream' ? <Dream /> : type === 'skill' ? <Skill /> : <Person />}
    </>
  );
}
